module.exports = __webpack_public_path__ + "img/wolf_460.08df6269.png";